<template>
  <div class="icon" ref="svg">
  <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.5665 14.6833C9.16531 14.6771 7.22309 12.7266 7.22741 10.3254C7.23143 7.92428 9.18014 5.98051 11.5813 5.98236C13.9824 5.98452 15.928 7.93138 15.928 10.3325C15.9222 12.7374 13.971 14.6836 11.5665 14.6833ZM11.5665 7.6556C10.0887 7.6593 8.89354 8.85941 8.89601 10.3372C8.89848 11.8149 10.0977 13.011 11.5754 13.0098C13.0532 13.0085 14.2505 11.8103 14.2505 10.3325C14.2468 8.85324 13.0461 7.6556 11.5665 7.6556ZM7.46058 20.9998C7.31975 20.9998 7.17893 20.9918 7.03903 20.976C5.39945 20.7802 4.09959 19.5001 3.87878 17.8636C3.76822 17.0143 3.96587 16.1533 4.43529 15.4372C4.13109 15.015 3.86519 14.5669 3.64067 14.0975C1.66664 14.1209 0.0422014 12.5496 0.000818351 10.5762C-0.0408735 8.60247 1.51562 6.96413 3.48904 6.90453C3.71695 6.37087 3.99737 5.8613 4.32658 5.38293C3.98872 4.79831 3.82443 4.12939 3.85284 3.45491C3.91955 1.88668 4.99242 0.541726 6.5063 0.127896C8.02017 -0.285935 9.62794 0.32709 10.4828 1.64332C11.1369 1.56241 11.7978 1.55499 12.4534 1.62108C13.2842 0.362606 14.8098 -0.246714 16.2789 0.092998C17.748 0.43271 18.8511 1.6498 19.0451 3.14515C19.1365 3.85546 19.0114 4.57657 18.6865 5.21492C19.0701 5.74426 19.3928 6.31497 19.6491 6.91626C20.5327 6.99254 21.3607 7.38043 21.9851 8.01044C22.6608 8.68801 23.0326 9.6111 23.0147 10.5679C22.9672 12.4943 21.4187 14.0456 19.4922 14.0971C19.2396 14.6249 18.9345 15.1262 18.5815 15.5934C19.2353 16.724 19.2263 18.1196 18.5577 19.2416C17.8891 20.3633 16.6658 21.0356 15.3604 20.9985C14.055 20.9612 12.8719 20.2203 12.2681 19.0622C11.7338 19.1045 11.1971 19.098 10.6641 19.0434C10.052 20.2484 8.81232 21.0056 7.46058 20.9998ZM3.87971 12.4119C4.39422 12.4128 4.85962 12.717 5.06715 13.1873C5.296 13.704 5.58568 14.191 5.93002 14.6388C6.29104 15.1061 6.29104 15.7583 5.93002 16.2256C5.47296 16.8192 5.40131 17.6243 5.74689 18.2889C6.09216 18.9538 6.79196 19.358 7.54056 19.3253C8.28916 19.2926 8.95068 18.829 9.23696 18.1363C9.46611 17.5931 10.0316 17.2713 10.6159 17.3519C11.1912 17.4291 11.774 17.4362 12.3512 17.3729C12.9201 17.3105 13.463 17.6261 13.6909 18.1511C14.0272 18.9433 14.8475 19.4173 15.7017 19.3126C16.5559 19.208 17.2378 18.5501 17.3727 17.6999C17.4503 17.2129 17.3351 16.7148 17.0519 16.3111C16.7261 15.8371 16.7492 15.2052 17.1087 14.7562C17.4926 14.279 17.8128 13.754 18.0614 13.1944C18.281 12.7012 18.7819 12.394 19.3211 12.4218C19.3499 12.4233 19.3789 12.4242 19.4079 12.4242C20.4558 12.4208 21.3109 11.5842 21.3369 10.5367C21.3449 10.0299 21.1466 9.54131 20.7878 9.18306C20.4039 8.79548 19.8811 8.57683 19.3357 8.57591H19.3332C18.8273 8.57714 18.3734 8.26492 18.1942 7.79148C17.9506 7.16178 17.618 6.57006 17.2066 6.03486C16.8823 5.6093 16.8511 5.0287 17.1282 4.57071C17.3459 4.20382 17.4348 3.77485 17.3799 3.35176C17.2711 2.52811 16.6479 1.86629 15.8323 1.70848C15.0167 1.55067 14.1915 1.93238 13.7835 2.65597C13.5198 3.12076 12.9997 3.37832 12.4704 3.30698C11.8107 3.22298 11.1424 3.23162 10.4852 3.3323C9.94665 3.41538 9.4133 3.15411 9.14894 2.67789C8.73357 1.91818 7.86267 1.52843 7.01926 1.72454C6.17585 1.92096 5.56653 2.65504 5.52916 3.52007C5.51218 3.92927 5.62737 4.33291 5.85807 4.67108C6.1635 5.12413 6.15176 5.71986 5.82934 6.16087C5.46987 6.65221 5.17555 7.18772 4.95289 7.75411C4.74999 8.27542 4.23486 8.6071 3.6765 8.57683C3.65117 8.5756 3.62492 8.57467 3.59867 8.57467C3.05761 8.57529 2.54124 8.80197 2.17497 9.20036C1.70648 9.71116 1.54898 10.4347 1.7633 11.0941C1.97763 11.7534 2.53013 12.2463 3.20986 12.3841C3.39299 12.4211 3.58045 12.4316 3.76637 12.4156C3.80435 12.4137 3.84234 12.4122 3.87971 12.4119Z" :fill="!actived?color:backgroundColor"/>  </svg>
  </div>
</template>

<script>
export default {
  name: 'iconSetting',
  watch: {
    $route: {
      deep: true,
      handler () {
        if (this.$refs.svg) {
          this.colorActived = new RegExp('router-link-exact-active', 'i').test(this.$refs.svg.parentNode.className)
        }
      }
    }
  },
  data () {
    return {
      colorActived: false
    }
  },
  created () {
    setTimeout(() => {
      if (this.$refs.svg) {
        this.colorActived = new RegExp('router-link-exact-active', 'i').test(this.$refs.svg.parentNode.className)
      }
    }, 100)
  },
  props: {
    actived: {
      type: Boolean
    },
    color: {
      type: String,
      default: 'var(--color-pri)'
    },
    backgroundColor: {
      type: String,
      default: 'var(--color-pri-letter)'
    }
  }
}
</script>

<style lang="scss" scoped>
.icon{
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 44px;
    height: 40px;
  }
}
</style>
